import { useTimezoneStore } from "@/stores/timezone";
import {
  formatChartDate,
  formatDate,
  formatDateTime,
  formatDateTimeShort,
} from "@/lib/dates";

/** Bound formatters that re-render when the app timezone preference changes. */
export function useFormatDate() {
  const mode = useTimezoneStore((s) => s.mode);

  return {
    mode,
    dateTime: (d: string | number | Date | null | undefined) => {
      if (d == null || d === "") return "—";
      return formatDateTime(d, mode) || "—";
    },
    date: (d: string | number | Date | null | undefined) => {
      if (d == null || d === "") return "—";
      return formatDate(d, mode) || "—";
    },
    dateTimeShort: (d: string | number | Date | null | undefined) => {
      if (d == null || d === "") return "";
      return formatDateTimeShort(d, mode);
    },
    chartDate: (d: string | number | Date | null | undefined) => {
      if (d == null || d === "") return "";
      return formatChartDate(d, mode);
    },
  };
}
